import { HomeInteractive } from '../../interfaces'
import { setGuestBannerHeight } from '../../actions/banners'
import { MAX_GUEST_HEIGHT, MAX_WIDTH } from '../../constants/banners'
import { BannersInteractiveMap } from '../../interfaces/banners'

export const guestSlider: HomeInteractive<BannersInteractiveMap> = (
  dispatch,
  interactiveState,
  _globalActions
) => ({
  wrapper_banners_guest: {
    attributes: {
      onDeferredLoad: () => {
        const resize = () => {
          const width =
            window.innerWidth > MAX_WIDTH ? MAX_WIDTH : window.innerWidth
          dispatch(
            setGuestBannerHeight(
              Math.floor((width / MAX_WIDTH) * MAX_GUEST_HEIGHT)
            )
          )
        }
        resize()
        window.addEventListener('resize', resize)
        return () => window.removeEventListener('resize', resize)
      },
      style: {
        minHeight: interactiveState.state.banners.heightGuest,
      },
    },
  },
})
